import type { OrderedExcalidrawElement } from "../../../../packages/element/src/types";
type Elements = readonly (OrderedExcalidrawElement & {
  url?: string;
  navigatedVersion: number;
})[];
export const hasDeletedPage = (
  previousElements: Elements | null,
  elements: Elements,
) => {
  if (previousElements == null) {
    return false;
  }
  const previousElementsMap = new Map(
    previousElements.filter((ele) => !!ele.url).map((ele) => [ele.id, ele]),
  );
  // const elementsMap = new Map(
  //   elements.filter((ele) => !!ele.url).map((ele) => [ele.id, ele]),
  // );
  for (const ele of elements) {
    if (!ele.url) {
      continue;
    }
    if (!previousElementsMap.get(ele.id)) {
      continue;
    }
    if (!ele.isDeleted) {
      continue;
    }

    const isChangedToDeleted =
      ele.isDeleted && !previousElementsMap.get(ele.id)?.isDeleted;

    const notChangedByOurFeature = ele.navigatedVersion !== ele.version;

    if (notChangedByOurFeature && isChangedToDeleted) {
      return true;
    }
  }
  return false;
};
